<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <navbar v-show="!anonymous"/>
    <div class="main-container">
      <app-main ref="appMain" :anonymous="anonymous" @handleConnect="handleConnect" @handleLink="handleLink" v-if="anonymous"/>
      <split-pane
        ref="splitPane"
        class="body-wrap"
        @resize="resize"
        split="vertical"
        v-else
        :min-percent='minPercent' :default-percent='defaultPercent'>
        <template slot="paneL">
          <sidebar class="sidebar-container" :class="menuSize" @handleConnect="handleConnect" style="border-right:none"/>
        </template>
        <template slot="paneR">
          <tags-view @handleDecisionClick="handleDecisionClick" @refreshData="refreshData"/>
          <app-main ref="appMain"  @handleConnect="handleConnect" @handleLink="handleLink"/>
        </template>
      </split-pane>
    </div>
    <!-- dialog表单 -->
    <report-dialog
      ref="reportDialog"
      :title="reportTitle"
      :connectProps="connectProps"
      :dataRow="dataRow"
      :model="model"
      :reportDialogVisible="reportDialogVisible"
      @reportDialogClose="handleReportDialogClose"/>
    <!-- 滑动表单 -->
    <report-slide
      ref="reportSlide"
      :connectProps="connectProps"
      :dataRow="dataRow"
      :model="model"
      :reportDialogVisible="reportSlideVisible"
      @reportDialogClose="reportSlideVisible=false"
      :title="reportTitle"/>
    <el-dialog title="选择单据" :visible.sync="recordListVisiable" width="400px">
      <div><el-table
          ref="recordList"
          :data="recordList"
          highlight-current-row
          @row-click="handleClickRecord"
          style="width: 100%">
          <el-table-column
            v-if="false"
            property="rid"
            label="rid">
          </el-table-column>
          <el-table-column
            property="userName"
            label="创建人">
          </el-table-column>
          <el-table-column
            property="fillDate"
            label="创建时间">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <div class="full_screen_div" @click="toggleFullScreen" v-if="showFullScreenDiv">
    <el-alert
      type="warning"
      :closable="false"
      show-icon
      center
      >
      <template slot="title">
        由于浏览器限制无法自动全屏，点击界面任意一处进入全屏模式
      </template>
    </el-alert>
    </div>
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import { Navbar, Sidebar, AppMain, TagsView } from './components'
import { getBarCodeLink, getBarCodeFormData } from '@/api/form'
import ResizeMixin from './mixin/ResizeHandler'
import ParamMixin from './mixin/ParamHandler'
import { decodeGBK } from 'gbk-string'
import { mapGetters } from 'vuex'
import ReportDialog from '@/components/ReportDialog/index.vue'
import ReportSlide from '@/components/ReportSlide/index.vue'
import { getOnlyOfficeSetting } from '@/api/largeFile'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    ReportDialog,
    ReportSlide,
    splitPane
  },
  mixins: [ResizeMixin, ParamMixin],
  computed: {
    menuSize() {
      return this.$store.state.app.menuSize
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    defaultPercent() {
      return this.$store.state.app.defaultPercent
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    ...mapGetters([
      'OEMInfo'
    ])
  },
  watch: {
    'sidebar.opened'(newVal) {
      this.getDefaultPercent()
    }
  },
  data() {
    return {
      minPercent: 0,
      reportTitle: '',
      connectProps: {},
      dataRow: {},
      model: 0,
      reportDialogVisible: false,
      reportSlideVisible: false,
      scanStart: false,
      code: '',
      gbkCode: '',
      keyCodeJson: {
        '65': 'a',
        '66': 'b',
        '67': 'c',
        '68': 'd',
        '69': 'e',
        '70': 'f',
        '71': 'g',
        '72': 'h',
        '73': 'i',
        '74': 'j',
        '75': 'k',
        '76': 'l',
        '77': 'm',
        '78': 'n',
        '79': 'o',
        '80': 'p',
        '81': 'q',
        '82': 'r',
        '83': 's',
        '84': 't',
        '85': 'u',
        '86': 'v',
        '87': 'w',
        '88': 'x',
        '89': 'y',
        '90': 'z',
        '48': '0',
        '49': '1',
        '50': '2',
        '51': '3',
        '52': '4',
        '53': '5',
        '54': '6',
        '55': '7',
        '56': '8',
        '57': '9',
        '96': '0',
        '97': '1',
        '98': '2',
        '99': '3',
        '100': '4',
        '101': '5',
        '102': '6',
        '103': '7',
        '104': '8',
        '105': '9',
        '106': '*',
        '107': '+',
        '109': '-',
        '110': '.',
        '111': '/',
        '186': ';',
        '187': '=',
        '188': ',',
        '189': '-',
        '190': '.',
        '191': '/',
        '192': '`',
        '219': '[',
        '220': '\\',
        '221': ']',
        '222': "'"
      },
      keyCodeJsonWithShift: {
        '65': 'A',
        '66': 'B',
        '67': 'C',
        '68': 'D',
        '69': 'E',
        '70': 'F',
        '71': 'G',
        '72': 'H',
        '73': 'I',
        '74': 'J',
        '75': 'K',
        '76': 'L',
        '77': 'M',
        '78': 'N',
        '79': 'O',
        '80': 'P',
        '81': 'Q',
        '82': 'R',
        '83': 'S',
        '84': 'T',
        '85': 'U',
        '86': 'V',
        '87': 'W',
        '88': 'X',
        '89': 'Y',
        '90': 'Z',
        '48': ')',
        '49': '!',
        '50': '@',
        '51': '#',
        '52': '$',
        '53': '%',
        '54': '^',
        '55': '&',
        '56': '*',
        '57': '(',
        '186': ':',
        '187': '+',
        '188': '<',
        '189': '_',
        '190': '>',
        '191': '?',
        '192': '~',
        '219': '{',
        '220': '|',
        '221': '}',
        '222': '"'
      },
      handleBarCodeInfo: {},
      recordListVisiable: false,
      recordList: [],
      showFullScreenDiv: false,
      anonymous: false,
      maxmum: false
    }
  },
  mounted() {
    window.onbeforeunload = () => {
      return '是否确定离开页面？'
    }
    // 初始化文件预览编辑功能
    getOnlyOfficeSetting().then(response => {
      var setting = response.data
      if (setting.active && setting.serverAddress) {
        const $script = document.createElement('script')
        global.document.body.appendChild($script)
        if (setting.serverAddress.indexOf('/', setting.serverAddress.length - 1) >= 0) {
          setting.serverAddress = setting.serverAddress.substr(0, setting.serverAddress.length - 1)
        }
        if (setting.storeAddress.indexOf('/', setting.storeAddress.length - 1) >= 0) {
          setting.storeAddress = setting.storeAddress.substr(0, setting.storeAddress.length - 1)
        }
        $script.src = `${setting.serverAddress}/web-apps/apps/api/documents/api.js`
        this.$store.dispatch('setOnlyOfficeSetting', setting)
      }
    })
    this.$store.dispatch('setAK')
    this.getDefaultPercent()
    window.onresize = () => {
      this.$nextTick(() => {
        this.getDefaultPercent()
      })
    }
    document.addEventListener('keydown', (e) => {
      const nextCode = e.keyCode || e.which
      if (nextCode === '16' || nextCode === '17') {
        return
      }
      var keyValue = e.shiftKey ? this.keyCodeJsonWithShift[nextCode] : this.keyCodeJson[nextCode]
      if (keyValue === undefined && nextCode !== 13 && nextCode !== 18) {
        return
      }
      if (this.scanStart) {
        if (keyValue === '|') {
          this.scanStart = false
          return
        }
        e.preventDefault()
        if (e.altKey && nextCode !== 18) {
          // 按住alt输入内容
          this.gbkCode += keyValue
          return
        }
        // 处理之前的GBK格式文本
        if (this.gbkCode !== '' && (nextCode === 18 || !e.altKey)) {
          this.gbkCode = parseInt(this.gbkCode).toString(16)
          this.gbkCode = '%' + this.gbkCode.slice(0, 2) + '%' + this.gbkCode.slice(2)
          this.code += decodeGBK(this.gbkCode)
          // 清空
          this.gbkCode = ''
        }
        if (!e.altKey && nextCode !== 13) {
          this.code += keyValue
        }
        // 输入回车符时结束扫码过程
        if (nextCode === 13) {
          // this.$message({
          //   message: this.code
          // })
          // 根据条码内容执行操作
          console.log(this.code)
          try {
            var codeParams = this.code.substring(1, this.code.length).split('&')
            this.scanStart = false
            this.code = ''
            this.handleBarCodeInfo.functionType = codeParams[0]
            this.handleBarCodeInfo.barCodeId = codeParams[1]
            this.handleBarCodeInfo.sourceTemplateId = codeParams[2]
            this.handleBarCodeInfo.targetTemplateId = codeParams[3]
            this.handleBarCodeInfo.sourceRecordId = codeParams[4]
            this.handleBarCodeInfo.targetMode = codeParams[5]
          } catch (ex) {
            this.$message.error('无效二维码！')
          }
          if (+this.handleBarCodeInfo.sourceRecordId) {
            // 判断功能类型
            switch (this.handleBarCodeInfo.functionType) {
              case '1':
                getBarCodeFormData(this.handleBarCodeInfo.barCodeId, this.handleBarCodeInfo.sourceTemplateId, this.handleBarCodeInfo.sourceRecordId).then(response => {
                  if (response.status >= 200 || response.status < 300) {
                    console.log('自动填充')
                    if (this.reportDialogVisible) {
                      this.$refs.reportDialog.$refs.report.$refs.reportEditor.handleAutoFill(response.data)
                      return
                    } else if (this.reportSlideVisible) {
                      this.$refs.reportSlide.$refs.report.$refs.reportEditor.handleAutoFill(response.data)
                      return
                    } else {
                      if (this.$refs.appMain.$refs.activeView.type === 'report') {
                        this.$refs.appMain.$refs.activeView.$refs.reportEditor.handleAutoFill(response.data)
                      } else {
                        this.$message.error('请先打开一个单据！')
                      }
                    }
                  }
                })

                break
              case '2':
                if (this.reportDialogVisible || this.reportSlideVisible) {
                  this.$message.error('当前状态无法新增单据！')
                  return
                }
                console.log('新建单据')
                if (this.handleBarCodeInfo.targetMode === '0') {
                  const routerTemp = {
                    name: `${this.handleBarCodeInfo.targetTemplateId}-${this.$t('buttons.create')}`,
                    nodeId: `create-${this.handleBarCodeInfo.argetTemplateId}`,
                    templateId: this.handleBarCodeInfo.targetTemplateId,
                    connectSource: 'barCode',
                    connectBarCodeId: this.handleBarCodeInfo.barCodeId,
                    connectTemplateId: this.handleBarCodeInfo.sourceTemplateId,
                    connectRecordId: this.handleBarCodeInfo.sourceRecordId,
                    routeType: 'create',
                    model: 0,
                    path: `/report/${this.handleBarCodeInfo.targetTemplateId}/0`
                  }
                  this.$router.push(routerTemp.path)
                  this.$store.dispatch('SetLastTab', routerTemp)
                  this.$store.dispatch('addView', routerTemp)
                } else {
                  this.title = `${this.handleBarCodeInfo.targetTemplateId}-${this.$t('buttons.create')}`
                  this.connectProps = {
                    templateId: this.handleBarCodeInfo.targetTemplateId,
                    connectSource: 'barCode',
                    connectBarCodeId: this.handleBarCodeInfo.barCodeId,
                    connectTemplateId: this.handleBarCodeInfo.sourceTemplateId,
                    connectRecordId: this.handleBarCodeInfo.sourceRecordId
                  }
                  this.dataRow = {
                    templateId: this.handleBarCodeInfo.targetTemplateId,
                    recordId: 0
                  }
                  this.model = 0
                  this.reportDialogVisible = true
                }
                break
              case '3':
                if (this.reportDialogVisible || this.reportSlideVisible) {
                  this.$message.error('当前状态无法打开单据！')
                  return
                }
                console.log('查看单据')
                getBarCodeLink(this.handleBarCodeInfo.barCodeId, this.handleBarCodeInfo.sourceTemplateId, this.handleBarCodeInfo.sourceRecordId).then(response => {
                  this.recordList = response.data
                  if (this.recordList.length > 0) {
                    if (this.recordList.length === 1) {
                      this.handleClickRecord({ rid: this.recordList[0].rid })
                    } else {
                      this.recordListVisiable = true
                    }
                  } else {
                    this.$message({
                      message: '没有找到关联单据！'
                    })
                  }
                })
                break
              default:
                this.$message.error('无效二维码！')
                break
            }
          } else {
            this.$message.error('请先保存单据再尝试！')
          }
        }
      } else {
        // 输入|符号时开始扫码过程
        if (keyValue === '|') {
          this.scanStart = true
          this.code = keyValue
          e.preventDefault()
          setTimeout(() => {
            // 超过一秒钟则视为退出扫描模式
            this.scanStart = false
          }, 1500)
        }
        // 正常输入
      }
    }, true)
  },
  methods: {
    getDefaultPercent() {
      const w = document.body.clientWidth
      if (this.device === 'desktop') {
        if (this.sidebar.opened) {
          const defaultPercent = localStorage.getItem('defaultPercent') ? +localStorage.getItem('defaultPercent') : (270 / w) * 100
          this.$store.dispatch('changeDefaultPercent', defaultPercent)
          this.$refs.splitPane.percent = defaultPercent
          this.minPercent = 10
        } else {
          this.minPercent = 100
          const defaultPercent = (38 / w) * 100
          this.$refs.splitPane.percent = defaultPercent
        }
      } else {
        this.minPercent = 100
        this.$refs.splitPane.percent = 0
      }
    },
    resize() {
      if (this.device === 'desktop' && this.sidebar.opened) {
        this.$store.dispatch('changeDefaultPercent', this.$refs.splitPane.percent)
      }
    },
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    },
    handleReportDialogClose() {
      this.reportDialogVisible = false
    },
    handleLink(dataRow, model, reportTitle) {
      this.dataRow = dataRow
      this.model = model
      this.reportTitle = reportTitle
      this.reportDialogVisible = true
    },
    handleConnect(dataRow, model, connectData, reportTitle, mode, mutableNames) {
      console.log('layout')
      this.dataRow = dataRow
      this.model = model
      this.connectProps = connectData
      this.reportTitle = reportTitle
      if (mode === 1) {
        this.reportDialogVisible = true
        this.$nextTick(() => {
          this.$refs.reportDialog.$refs.report.mutableNames = mutableNames
        })
      } else if (mode === 2) {
        this.reportSlideVisible = true
        this.$nextTick(() => {
          this.$refs.reportSlide.$refs.DialogReportEditor.mutableNames = mutableNames
        })
      } else {
        this.reportDialogVisible = true
      }
    },
    handleClickRecord(row) {
      this.recordListVisiable = false
      if (this.handleBarCodeInfo.targetMode === '0') {
        const routerTemp = {
          name: `${this.handleBarCodeInfo.targetTemplateId}-${this.$t('buttons.check')}`,
          nodeId: `check-${this.handleBarCodeInfo.argetTemplateId}`,
          templateId: this.handleBarCodeInfo.targetTemplateId,
          recordId: row.rid,
          routeType: 'check',
          model: 2,
          path: `/report/${this.handleBarCodeInfo.targetTemplateId}/${row.rid}/2`
        }
        this.$router.push(routerTemp.path)
        this.$store.dispatch('SetLastTab', routerTemp)
        this.$store.dispatch('addView', routerTemp)
      } else {
        this.title = `${this.handleBarCodeInfo.targetTemplateId}-${this.$t('buttons.check')}`
        this.dataRow = {
          templateId: this.handleBarCodeInfo.targetTemplateId,
          rid: row.rid
        }
        this.model = 2
        this.reportDialogVisible = true
      }
    },
    handleDecisionClick(decisionId) {
      this.$refs.appMain.handleDecisionClick(decisionId)
    },
    refreshData(decisionId) {
      this.$refs.appMain.refreshData(decisionId)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
    .el-breadcrumb__item{
      float:none;
      font-size: 12px;
      cursor: pointer;
      a{
        color:#666;
        font-weight: normal;
        cursor: pointer;
      }
    }
    .full_screen_div{
      height: 100vh;
      width: 100vw;
      cursor: pointer;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 9999;
      background-color: rgba(255,255,255,0.3);
      .el-alert{
        left: 50%;
        position: absolute;
        top: 50%;
        width: auto;
        transform: translate(-50%,-50%);
      }
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
</style>
